module.exports = __webpack_public_path__ + "img/flowers-card-1440.bb0c3f67.jpg";